import { FC } from "react";
import b2bMvpApi from "../../../api/b2b";
import { useAsync } from "../../../utils";
import useViewModel from "../../../viewModel/base";
import Loading from "../../shared/Loading";
import { Form, Modal } from "react-bootstrap";
import { Toast } from "../../../service/alert";

const MAP_DATA: any = {
    STT: "STT",
    mProductName: "Tên sản phẩm",
    mPkgName: "Loại đóng gói",
    mImage: "Hình ảnh sản phẩm",
    mCategory: "Phân nhóm",
    mDistributorName: "Nhà cung cấp",
    mPrice: "Giá bán",
    mPackingType: "Quy cách đóng gói",
};

const ImportDistributorInventory: FC = () => {
    const {
        execute: importDistributorInventory,
        status: importDistributorInventoryStatus,
        value: importResponse,
    } = useAsync<any>(b2bMvpApi.importDistributorInventory);

    const viewModel = useViewModel({
        ggsheet: "",
        showModal: false,
    });

    return (
        <div>
            {importDistributorInventoryStatus == "loading" && (
                <div className="overlay-wrapper">
                    <div className="wrap-loading">
                        <Loading />
                    </div>
                </div>
            )}
            <label className="mt-4" htmlFor="ggsheet">
                <b>Google sheet:</b>
            </label>
            <textarea
                placeholder={""}
                autoComplete="off"
                className="w-100 p-2"
                style={{
                    border: "1px solid #d1d1d1",
                    borderRadius: 5,
                    minHeight: 100,
                }}
                onChange={(e) => {
                    viewModel.updateData({ ggsheet: e.target.value });
                }}
            />

            <div className="fixed-button">
                <a
                    onClick={(e) => {
                        e.preventDefault();
                        importDistributorInventory(viewModel.data.ggsheet).then((res) => {
                            if (res == "ok") {
                                Toast.fire({
                                    icon: "success",
                                    title: "Import thành công",
                                    text: "Sản phẩm đã được update vào hệ thống!",
                                });
                            } else {
                                viewModel.updateData({ showModal: true });
                            }
                        });
                    }}
                    className={`btn btn-block ${!viewModel.data.ggsheet ? "disabled" : ""}`}
                    href="/#"
                >
                    Xử lí file
                </a>
            </div>
            <Modal
                dialogClassName="product-update fullscreen"
                show={viewModel.data.showModal}
                onHide={() => viewModel.updateData({ showModal: false })}
            >
                <div className="p-2 pt-4">
                    <h6 className="text-center">
                        <img width={30} src="./images/success.svg" />
                        {importResponse?.details && importResponse?.details[1] ? importResponse?.details[1].message : "Xử lí file thành công"}
                    </h6>
                    <div>{importResponse?.message}</div>
                    {importResponse?.details && (
                        <>
                            <div className="mt-4 mb-2">
                                <h6 className="text-center" style={{ color: "red" }}>
                                    <img
                                        width={30}
                                        src="https://media.istockphoto.com/vectors/cross-vector-icon-false-or-wrong-icon-vector-illustration-vector-id1219761871"
                                    />{" "}
                                    {importResponse?.details[0]?.message.length} sản phẩm lỗi:
                                </h6>
                            </div>
                            {importResponse?.details[0]?.message.map((x: any) => {
                                return (
                                    <p className="mt-2">
                                        {Object.keys(MAP_DATA).map((key) => {
                                            console.log("key: ", key);
                                            return (
                                                <div className="d-flex justify-content-between mt-2">
                                                    <b>{MAP_DATA[key]} :</b>{" "}
                                                    <div>
                                                        {MAP_DATA[key] == MAP_DATA.mImage ? (
                                                            <img src={x[MAP_DATA[key]]} alt="Hình ảnh lỗi" width={30} />
                                                        ) : (
                                                            <>{x[MAP_DATA[key]] || <b style={{ color: "red" }}>Chưa nhập</b>}</>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <div className="text-center">- - - - - - - - - - - - - - - - - - - - - -</div>
                                    </p>
                                );
                            })}
                        </>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default ImportDistributorInventory;
